import styled from 'styled-components';

import { Card } from 'components/Page';
import { CardProps } from 'components/Page/Card/Card';

export const AttachmentsCard = styled(Card)<CardProps>`
  margin: ${({ theme }) => theme.spacing(3, 0, 0)};
`;
